import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';

import { AppActions } from '../../../core/store/actions/app';
import { MaintenancePeriodService } from '../../services/maintenancePeriod.service';
import { setCurrentMaintenancePeriod } from '../actions/maintenancePeriods';

@Injectable()
export class MaintenancePeriodsEffects {
    loadCurrentMaintenancePeriod$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AppActions.initialized),
            switchMap(() =>
                this.maintenancePeriodService
                    .getCurrent()
                    .pipe(map((maintenancePeriod) => setCurrentMaintenancePeriod({ maintenancePeriod }))),
            ),
        ),
    );

    constructor(
        private actions$: Actions,
        private maintenancePeriodService: MaintenancePeriodService,
    ) {}
}
